import { useQuery } from 'react-query'

import { useUserOrganization } from '@modules-deprecated/app/organization'

import { QueryKeys } from '../../../enums/queryKeys'
import { fetchSelectableProductAccounts, SelectableProductAccount } from '../query-api'

interface UseSelectableProductAccountsProps {
  enabled?: boolean
}

interface UseSelectableProductAccountsResponse {
  accounts: SelectableProductAccount[]
  isLoading: boolean
}

/**
 * Fetches the platform-curated list of accounts a product's `accountId` may be set to (STR-111).
 * Only meaningful for French organizations - callers should gate rendering (and therefore this
 * hook running) on `organization.countryId === 'FR'` so the request is never made for other orgs.
 */
export const useSelectableProductAccounts = ({
  enabled = true,
}: UseSelectableProductAccountsProps = {}): UseSelectableProductAccountsResponse => {
  const { organization } = useUserOrganization()

  const { data, isLoading } = useQuery(
    [QueryKeys.SelectableProductAccounts, organization?.id],
    () => fetchSelectableProductAccounts(),
    {
      enabled: enabled && !!organization?.id,
    },
  )

  return {
    accounts: data ?? [],
    isLoading,
  }
}
